import { WidgetControlType } from '@examdojo/core/widget';

import type { QuadraticPreset } from './quadratic-preset.model';

export const TUTORING_PRESET: QuadraticPreset = {
  id: 'tutoring',
  title: 'Tutoring Mode',
  description: 'Guided exploration with focus controls',
  config: {
    id: 'quadratic-tutoring',
    type: 'quadratic-function',
    params: {
      a: 1,
      b: 0,
      c: -4,
    },
    display: {
      grid: false,
      axes: true,
      vertex: { enabled: true, label: { show: true, format: 'name' } },
      roots: { enabled: true, label: { show: true, format: 'name' } },
      axisOfSymmetry: false,
      parabola: { strokeWidth: 3 },
    },
    behavior: {
      features: {
        sliders: false,
        interaction: false,
      },
      controls: [
        {
          id: 'focus-group',
          type: WidgetControlType.ButtonGroup,
          label: 'Focus Controls',
          position: 'bottom-bar',
          buttons: [
            {
              id: 'focus-vertex',
              label: 'Vertex',
              icon: 'crosshairs',
              showLabel: true,
              trigger: { action: 'FOCUS_REGION', payload: { region: 'vertex' } },
            },
            {
              id: 'focus-roots',
              label: 'Roots',
              icon: 'bullseye',
              showLabel: true,
              trigger: { action: 'FOCUS_REGION', payload: { region: 'roots' } },
            },
            {
              id: 'zoom-out',
              label: 'Overview',
              icon: 'expand',
              showLabel: true,
              trigger: { action: 'RESET_VIEW' },
            },
          ],
        },
      ],
    },
  },
};
